// Aggregates the v2 experiment lane files into one array router.tsx renders once.
// See app/v2/README.md for the campaign rules. Do not add routes here directly.
import { kitRoutes } from './kit';
import { slot1Routes } from './slot1';
import { slot2Routes } from './slot2';
import { slot3Routes } from './slot3';
import { slot4Routes } from './slot4';
import { slot5Routes } from './slot5';
import { slot6Routes } from './slot6';

export const v2Routes = [
  ...kitRoutes,
  ...slot1Routes,
  ...slot2Routes,
  ...slot3Routes,
  ...slot4Routes,
  ...slot5Routes,
  ...slot6Routes,
];
